import React, { Component } from 'react'
import { observer } from "mobx-react";
import 'Styles/commonComponents/FiltersPanel/FilterBlockDateTimeRange.scss';
import FilterBlock from "Components/Common/filterBlock";
import DateTimePicker from 'Components/Common/DateTimePicker';
import HelperDatePickerRange from "Utils/HelperDatePickerRange";

/**
 * @typedef {object} props
 * @property {string} [className]
 * @property {boolean} [timeVisible]
 * @property {() => Date | null} getValueFrom
 * @property {(date: Date | null) => void} setValueFrom
 * @property {() => Date | null} getValueTo
 * @property {(date: Date | null) => void} setValueTo
 * @property {() => Date} [getMinDate]
 * @property {() => Date} [getMaxDate]
 * @property {() => any | null} getRenderStore
 * @property {(store: any) => void} setRenderStore
 * @property {string} title
 * @property {boolean} disabled
 * @property {boolean} isTop
 * @extends {Component<props>}
 */
class FilterBlockDateTimeRange extends Component {

    constructor() {
        super();
    }

    GetRenderStore() {
        let valDefault = {
            from: {},
            to: {},
        };
        let ret = this.props.getRenderStore();
        if (ret == null)
            this.props.setRenderStore(valDefault);
        return ret ?? valDefault;
    }

    IsTimeVisible() {
        return this.props.timeVisible != false;
    }

    MinDateFrom() {
        return (this.props.getMinDate == null || this.props.getMinDate() == null) ? HelperDatePickerRange.GetMinDateFrom() : this.props.getMinDate();
    }

    MaxDateTo() {
        return HelperDatePickerRange.GetMaxDateToExistedValues();
    }

    render() {
        return (
            <FilterBlock
                title={this.props.title}
                className={`${this.props.className} ${this.props.disabled ? "disabled" : ""}`}
            >
                <div className={`FilterBlockDateTimeRange ${this.IsTimeVisible() ? "FilterBlockDateTimeRange-with-time" : "FilterBlockDateTimeRange-date-only"}`}>
                    <div className="filter-direction-with-title-container">
                        <div className="filter-direction-title">
                            С
                        </div>
                        <div className="filter-direction-value-container">
                            <DateTimePicker
                                className="datetime-filter-from"
                                getRenderStore={() => this.GetRenderStore().from}
                                setRenderStore={val => this.GetRenderStore().from = val}
                                getValue={() => this.props.getValueFrom()}
                                setValue={val => this.props.setValueFrom(val)}
                                getMinDate={() => this.MinDateFrom()}
                                getMaxDate={() => HelperDatePickerRange.GetMaxDateFrom(this.props.getValueTo(), this.MaxDateTo())}
                                timeVisible={this.IsTimeVisible()}
                                isTop={this.props.isTop}
                                isDefaultTimeEndOfDay={false}
                            />
                        </div>
                    </div>
                    <div className="filter-direction-with-title-container">
                        <div className="filter-direction-title">
                            По
                        </div>
                        <div className="filter-direction-value-container">
                            <DateTimePicker
                                className="datetime-filter-to"
                                getRenderStore={() => this.GetRenderStore().to}
                                setRenderStore={val => this.GetRenderStore().to = val}
                                getValue={() => this.props.getValueTo()}
                                setValue={val => this.props.setValueTo(val)}
                                getMinDate={() => HelperDatePickerRange.GetMinDateTo(this.props.getValueFrom(), this.MinDateFrom())}
                                getMaxDate={() => this.MaxDateTo()}
                                timeVisible={this.IsTimeVisible()}
                                isTop={this.props.isTop}
                                isDefaultTimeEndOfDay={true}
                            />
                        </div>
                    </div>
                </div>
            </FilterBlock>
        )
    }
};

export default observer(FilterBlockDateTimeRange);